module.exports = "/_next/static/images/BuildDeeper@2x-b36d854e98adee139a5a1084456fb7e9.png";